import type { TrainingType } from '@/entities/Training';

export const TABBED_TRAINING_TYPES: readonly TrainingType[] = [
  'SGQ_DOCUMENT_FOCAL',
  'SGQ_DOCUMENT_HOMOLOGATION',
  'OPEN_TRAINING',
];

export function isTabbedTrainingType(type: TrainingType): boolean {
  return TABBED_TRAINING_TYPES.includes(type);
}
